import { useState } from "react";
import axios from "axios";
import { RefreshCw } from "lucide-react";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function RefreshEndcardButton({ video, onQueued }) {
  const [busy, setBusy] = useState(false);

  const run = async () => {
    if (!window.confirm(
      `Rebuild the end-card for "${video.title}"?\n\nThe video re-renders with the current title and short link baked in. Attached clips are kept. Takes a few minutes — the story stays live meanwhile.`
    )) return;
    setBusy(true);
    try {
      await axios.post(`${API}/videos/${video.id}/endcard/refresh`);
      toast.success("End-card rebuild started — the story stays live while it re-renders");
      onQueued && onQueued();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't start the rebuild");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      onClick={run}
      disabled={busy || video.tails_updating}
      className="text-[11px] uppercase tracking-[0.18em] py-2 rounded-lg border border-white/10 hover:border-[color:var(--accent)] hover:text-[color:var(--accent)] transition-colors flex items-center justify-center gap-1.5 disabled:opacity-50"
      data-testid={`library-refresh-endcard-${video.id}`}
      title="Re-render this story so the end-card shows the current title + short link (keeps added clips)"
    >
      <RefreshCw className={`w-3.5 h-3.5 ${busy ? "animate-spin" : ""}`} />
      End-card
    </button>
  );
}
